<template>
  <div>
    <TheNavbar />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import TheNavbar from "@/components/TheNavbar.vue";

export default {
  components: {
    TheNavbar
  }
};
</script>
<style>
:root {
  --color-primary: #131f41;
  --color-secondary: #026c7c;
  --color-tertiary: #81717a;
  --color-quaternary: #f7f0f5;
  --color-quinary: #e3b505;
  --color-senary: #d52941;
  --color-white: #ffffff;
  --color-black: #000000;
}

@font-face {
  font-family: "Open Sans Regular";
  src: local("Open Sans Regular"),
    url("./assets/fonts/opensans-regular-webfont.woff2") format("woff2"),
    url("./assets/fonts/opensans-regular-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

html {
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

body,
input,
select,
textarea,
button {
  font-family: "Open Sans Regular", Arial, Helvetica, sans-serif;
}

body {
  font-weight: 400;
  line-height: 1.75;
  margin: 0;
  padding: 0;
  background-color: var(--color-quaternary);
  display: flex;
  flex-direction: column;
}

#app {
  display: flex;
  flex-direction: column;
}

html,
body,
div,
nav,
p,
span,
ul,
li,
img,
svg,
form,
input,
select {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-weight: 400;
  line-height: 1.3;
  color: var(--color-primary);
}

h1 {
  margin-top: 0;
  font-size: 2.488rem;
}

h2 {
  font-size: 2.074rem;
}

h3 {
  font-size: 1.728rem;
}

h4 {
  font-size: 1.44rem;
  font-weight: 600;
}

h5 {
  font-size: 1.2rem;
  font-weight: 600;
}

p {
  color: var(--color-primary);
}

small {
  font-size: 0.833rem;
}

button {
  cursor: pointer;
  white-space: nowrap;
}

ul {
  list-style: none;
}

ul,
p {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}

input,
textarea,
select {
  background-color: var(--color-white);
  color: var(--color-primary);
  border-radius: 10px;
  border: 2px solid var(--color-tertiary);
  outline: none;
  font-size: 1rem;
  padding: 0.8rem;
  -webkit-appearance: caret!important;
}

input:focus,
textarea:focus,
select:focus {
  border-color: var(--color-primary);
}

label {
  font-size: 0.85rem;
  display: flex;
  flex-direction: column;
}

label:focus-within {
  color: var(--color-primary) !important;
}

a,
a:visited,
a:active {
  text-decoration: none;
}

form {
  display: flex;
  flex-direction: column;
}

input[type="checkbox"] {
  all: unset;
  margin: 0 0.4rem 0 0;
  background-color: #fff;
  border: 2px solid var(--color-tertiary);
  border-radius: 6px;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: all;
}

input[type="checkbox"]:checked {
  border-color: var(--color-secondary);
}

input[type="checkbox"]:checked::after {
  content: "\2713\0020";
  color: var(--color-secondary);
  font-size: 1.6rem;
  font-weight: bold;
  position: relative;
  top: -10px;
  left: 1.5px;
}

input[type="date"] {
  width: 100%;
}

.container {
  margin: 1.6rem 1rem 0 1rem;
}

.chart {
  margin: auto 0 auto 0;
}

.error-message,
.success-message,
.failure-message {
  transition: display 800ms ease-in-out;
  margin-left: 0!important;
  margin-right: 0!important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
